import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#F5E6E0] sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <span className="font-bold text-xl text-[#bc6355]">beLEGEND SOY PROTEIN</span>
        </div>
      </header>

      {/* Breadcrumb Navigation */}
      <nav className="bg-[#FFF9F7] border-b border-[#F5E6E0]">
        <div className="container mx-auto px-6 py-3">
          <ul className="flex items-center gap-2 text-sm">
            <li>
              <a 
                href="https://soyproteinranking.com/" 
                className="flex items-center gap-2 text-[#D4A59A] hover:text-[#bc6355] transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center text-[#bc6355]">
                  <i className="ri-home-4-line"></i>
                </span>
                <span>トップ</span>
              </a>
            </li>
            <li className="text-[#E8D4CF]">/</li>
            <li className="text-[#6B5750] whitespace-nowrap">ビーレジェンドで理想の自分へ、最短距離で</li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Hero Section */}
        <div className="mb-12">
          <h1 className="text-3xl font-bold text-white mb-6 bg-gradient-to-r from-[#bc6355] to-[#D4A59A] px-6 py-4 rounded-lg leading-tight">
            beLEGEND SOYで理想のボディをデザインする
          </h1>
          <p className="text-[#6B5750] leading-relaxed mb-4">
            「ソイプロテインは美味しくない」「ダマになりやすくて飲みにくい」「続けたいけど価格が高い」と妥協したことはありませんか？
          </p>
          <p className="text-[#6B5750] leading-relaxed">
            <span className="text-[#bc6355] font-semibold underline decoration-[#F5E6E0] decoration-4">
              beLEGEND（ビーレジェンド）WEIGHT DOWN
            </span>
            は、
            <span className="border-b-2 border-[#bc6355] font-semibold">
              モンドセレクション最高金賞受賞
            </span>
            の品質を誇り、圧倒的な美味しさと溶けやすさを実現した、ダイエッターに支持される本格ソイプロテインです。
          </p>
        </div>

        {/* Features Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            beLEGENDの特徴や概要
          </h2>
          <p className="text-[#6B5750] leading-relaxed mb-6">
            <span className="text-[#bc6355] font-semibold">beLEGEND SOY PROTEIN</span>
            は、多くのアスリートやダイエッターに愛用されている「美味しさ」と「コスパ」を追求したブランドです。
          </p>
          <p className="text-[#6B5750] leading-relaxed mb-8">
            最大の特徴は、大豆特有のクセを抑えた
            <span className="border-b-2 border-[#bc6355] font-semibold">
              「ご褒美」のようなフレーバー
            </span>
            です。さらに、カルシウムや鉄分、7種類のビタミンを配合し、ただタンパク質を摂るだけでなく、美容と健康の土台作りを徹底サポートします。
          </p>

          <h3 className="text-xl font-bold text-[#6B5750] mb-6">beLEGENDがひと目でわかる!</h3>
          <div className="overflow-hidden rounded-lg border border-[#F5E6E0] shadow-sm mb-8 bg-white">
            <table className="w-full">
              <thead>
                <tr className="bg-[#FFF9F7]">
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0] w-1/3">
                    項目
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#6B5750] border-b border-[#F5E6E0]">
                    内容
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#F5E6E0]">
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">品質評価</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">モンドセレクション最高金賞を連続受賞</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">配合成分</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">大豆タンパク / 7種のビタミン / 鉄・カルシウム</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">味わい</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">濃厚バナナ・抹茶・チョコなど豊富なフレーバー</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">溶けやすさ</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">シェイカーですぐに溶ける独自の粉末加工</td>
                </tr>
                <tr className="hover:bg-[#FFF9F7] transition-colors">
                  <td className="px-6 py-4 bg-[#bc6355] text-white font-semibold text-sm">コスパ</td>
                  <td className="px-6 py-4 text-[#6B5750] text-sm">1食あたりの価格を抑え、継続しやすさを重視</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Usage Points Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            beLEGENDの活用ポイント
          </h2>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              1.「腹持ち抜群」で減量をしっかりサポート
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              大豆由来の植物性タンパク質は吸収が穏やかなため、
              <strong className="text-[#bc6355]">満足感が長時間持続</strong>
              します。ダイエット中の空腹ストレスを軽減し、理想の体づくりを後押しします。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              2.ビタミン・ミネラル配合の「トータル美容」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              <strong className="text-[#bc6355]">美容に欠かせない成分</strong>
              をバランスよく配合。食事制限で不足しがちな栄養を補いながら、健康的で美しいシルエットを目指せます。
            </p>
          </div>
          <div className="mb-8">
            <h4 className="text-lg font-bold text-[#6B5750] mb-4 border-b-2 border-[#F5E6E0] pb-2 inline-block">
              3.驚きのフレーバー再現度と「溶けやすさ」
            </h4>
            <p className="text-[#6B5750] leading-relaxed">
              「プロテインは飲みにくい」という常識を覆す
              <strong className="text-[#bc6355]">本格的な味わい</strong>
              。さらっとした喉越しでダマにならないため、運動後や忙しい朝でもストレスなく飲み続けられます。
            </p>
          </div>
        </section>

        {/* Recommended For Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            beLEGENDはこんな人におすすめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                CHECK!
              </span>
            </div>
            <ol className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  1
                </div>
                <p className="text-[#6B5750]">とにかく美味しいプロテインで、楽しくダイエットを続けたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  2
                </div>
                <p className="text-[#6B5750]">朝食や間食を置き換えて、お腹をしっかり満たしたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  3
                </div>
                <p className="text-[#6B5750]">ビタミンや鉄分など、美容に嬉しい成分も同時に摂りたい</p>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#bc6355] text-white flex items-center justify-center text-sm font-semibold mt-0.5">
                  4
                </div>
                <p className="text-[#6B5750]">コストパフォーマンスに優れた、信頼の国内メーカーを選びたい</p>
              </li>
            </ol>
          </div>
        </section>

        {/* Summary Section */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#6B5750] mb-6 pb-3 border-b-4 border-[#bc6355]">
            まとめ
          </h2>
          <div className="bg-gradient-to-br from-[#FFF9F7] to-[#FFF5F2] rounded-xl p-8 border border-[#F5E6E0] shadow-sm">
            <div className="flex items-center justify-center mb-6">
              <span className="bg-[#bc6355] text-white px-4 py-2 rounded-full text-sm font-bold">
                POINT
              </span>
            </div>
            <div className="space-y-4 text-[#6B5750]">
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">確かな品質:</strong> 世界に認められた最高品質の味わいと栄養バランス
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">抜群の溶けやすさ:</strong> ダマにならず、ストレスフリーな飲用体験
                </span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-[#bc6355] font-bold">•</span>
                <span>
                  <strong className="text-[#bc6355]">継続できる価格:</strong> 高品質ながらリーズナブルで毎日の習慣に最適
                </span>
              </p>
            </div>
          </div>
          <p className="text-[#6B5750] leading-relaxed mt-8 text-center font-bold">
            「飲むのが楽しみになる」体験で、理想の身体を手に入れませんか。
          </p>

          {/* Product Image */}
          <a
            href="https://soyproteinranking.com/web/beLEGEND.php?p=sh"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-12 cursor-pointer hover:opacity-90 transition-opacity"
          >
            <div className="w-full h-auto">
              <img
                alt="beLEGEND WEIGHT DOWN - 高機能ソイプロテイン"
                className="w-full h-auto rounded-lg shadow-md object-cover"
                src="https://static.readdy.ai/image/c28b677376caa266f389c59db123aec1/00f9fc4c88a9fd3bf8942e6077f94f96.png"
              />
            </div>
          </a>

          {/* CTA Section */}
          <div className="mt-8 bg-[#bc6355] rounded-lg py-8 px-6 text-center">
            <p className="text-white text-sm font-medium mb-4 tracking-wide">
              モンドセレクション最高金賞受賞ブランド
            </p>
            <a
              href="https://soyproteinranking.com/web/beLEGEND.php?p=sh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FFF9F7] rounded-lg px-8 py-4 mb-6 cursor-pointer hover:shadow-lg transition-shadow"
            >
              <p className="text-[#8B7B74] text-xs mb-1">プロテインは美味しさで選ぶ</p>
              <p className="text-[#bc6355] text-2xl font-bold tracking-wide">beLEGEND</p>
              <p className="text-[#bc6355] text-xs tracking-widest">SOY PROTEIN</p>
            </a>
            <div>
              <a
                href="https://soyproteinranking.com/web/beLEGEND.php?p=sh"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-block bg-white text-[#bc6355] font-bold py-4 px-12 rounded-full cursor-pointer hover:shadow-lg transition-all overflow-hidden group whitespace-nowrap"
              >
                <span className="relative z-10">beLEGEND SOYの詳細を見る</span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}